import { t } from "@/i18n-js/instance";
import { type PlanTiers, planTiers } from "@/react/helpers/planHelpers";

const localeRoot =
  "pricing_plans.plan_settings.plan_selection.plan_selector.plan_card.tier_highlights";

export type PublicPlanTiers = Exclude<PlanTiers, "plus">;

export const tierHighlights: Record<PublicPlanTiers, string[]> = {
  basic: [
    t(`${localeRoot}.basic.rich_member_profiles`),
    t(`${localeRoot}.basic.search_member_profiles`),
    t(`${localeRoot}.basic.discussions`),
    t(`${localeRoot}.basic.events`),
    t(`${localeRoot}.basic.paid_memberships`),
    t(`${localeRoot}.basic.weekly_digest`),
    t(`${localeRoot}.basic.gamification`),
    t(`${localeRoot}.basic.custom_domain`),
  ],
  professional: [
    t(`${localeRoot}.professional.courses`),
    t(`${localeRoot}.professional.website_builder`),
    t(`${localeRoot}.professional.live_streams`),
    t(`${localeRoot}.professional.live_rooms`),
    t(`${localeRoot}.professional.unlimited_members`),
    t(`${localeRoot}.professional.custom_branding`),
    t(`${localeRoot}.professional.reporting_and_analytics`),
    t(`${localeRoot}.professional.custom_code_snippets`),
    t(`${localeRoot}.professional.conversion_tracking`),
  ],
  business: [
    t(`${localeRoot}.business.workflows`),
    t(`${localeRoot}.business.custom_profile_fields`),
    t(`${localeRoot}.business.headless_member_api`),
    t(`${localeRoot}.business.admin_api`),
    t(`${localeRoot}.business.branded_email_notifications`),
    t(`${localeRoot}.business.content_co_pilot`),
    t(`${localeRoot}.business.automated_transcriptions`),
    t(`${localeRoot}.business.activity_scores`),
  ],
  enterprise: [
    t(`${localeRoot}.enterprise.ai_agents`),
    t(`${localeRoot}.enterprise.ai_workflows`),
    t(`${localeRoot}.enterprise.unlimited_workflows`),
    t(`${localeRoot}.enterprise.custom_sso`),
    t(`${localeRoot}.enterprise.priority_support`),
    t(`${localeRoot}.enterprise.advanced_analytics`),
    t(`${localeRoot}.enterprise.lower_transaction_fees`),
    t(`${localeRoot}.enterprise.sandbox_community`),
    t(`${localeRoot}.enterprise.up_to_10_admins_and_100_moderators`),
    t(`${localeRoot}.enterprise.concierge_onboarding`),
    t(`${localeRoot}.enterprise.dedicated_csm`),
  ],
};

export const isValidPublicPlanTier = (
  tier: PlanTiers,
): tier is PublicPlanTiers => tier !== planTiers.plus;
